export default __webpack_public_path__ + "static/media/img10.b5a1e122.PNG";